import DateAndOrTimePicker from '@/Controls/DateAndOrTimePickerBase';
import ComponentManager from '@/Management/ComponentManager';
import DatePickerViewModelType from '@/ViewModels/Controls/DatePickerViewModel';
import * as DateHelper from '@/Utility/DateHelper'

export default class DatePicker extends DateAndOrTimePicker {
    public constructor(protected viewModel: DatePickerViewModelType, protected element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null)
            return this.jQueryControl;

        this.jQueryControl = this.createControl(this.element, 'date', 'k-textbox');

        this.widget(null);

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'datepicker'
        });

        super.onWidgetCreatedCallback(widget);

        this.applyBindings(this.jQueryControl.find('input'), {
            attr: {
                min: this.defineComputed(() => {
                    return DateHelper.extractDateFromDate(this.viewModel.min());
                }),
                max: this.defineComputed(() => {
                    return DateHelper.extractDateFromDate(this.viewModel.max());
                })
            }
        });
    }
}

ComponentManager.setControl('DatePicker', DatePicker, 'RADPresentation.HTMLClient.DefaultViewExtensions');